import { InternalError } from '../../errors';
import { Network } from 'aptos';
export const NetworkMapping = {
    AptosDevnet: Network.DEVNET,
    AptosMainnet: Network.MAINNET,
    AptosTestnet: Network.TESTNET,
};
export class AptosProviderWrapper {
    get blockchainNetwork() {
        return this._blockchainNetwork;
    }
    async address() {
        var _a;
        const account = await ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.account());
        return account === null || account === void 0 ? void 0 : account.address;
    }
    async publicKey() {
        var _a;
        const account = await ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.account());
        return account === null || account === void 0 ? void 0 : account.publicKey;
    }
    constructor(blockchainNetwork) {
        this._blockchainNetwork = blockchainNetwork;
    }
    async connected() {
        var _a;
        return (await ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.isConnected())) || false;
    }
    async connect() {
        if ('aptos' in window) {
            this._wallet = window.aptos;
            await this._wallet.connect();
        }
        else {
            throw new InternalError('Aptos wallet not installed');
        }
        return;
    }
    async disconnect() {
        var _a;
        if (await ((_a = this._wallet) === null || _a === void 0 ? void 0 : _a.disconnect())) {
            return;
        }
    }
    async signMessage(message) {
        if (!this._wallet) {
            throw new InternalError('Aptos wallet not initialized');
        }
        const response = await this._wallet.signMessage({
            message: message,
            nonce: '0',
        });
        return {
            signature: response.signature,
            publicKey: (await this.publicKey()),
            network: this._blockchainNetwork,
        };
    }
    async mint(contractAddress, mintDetails) {
        if (!this._wallet) {
            throw new InternalError('Aptos wallet not initialized');
        }
        contractAddress = contractAddress.startsWith('0x') ? contractAddress : `0x${contractAddress}`;
        const sigBytes = Uint8Array.from(Buffer.from(mintDetails.signature, 'hex'));
        const args = [
            mintDetails.metadata_cid,
            mintDetails.expiry,
            mintDetails.seconds_to_pay,
            mintDetails.verification_tier,
            sigBytes,
        ];
        const pendingTx = await this._wallet.signAndSubmitTransaction({
            function: `${contractAddress}::kycdao_sbt::mint_with_signature`,
            type_arguments: [],
            arguments: args,
        });
        return pendingTx.hash;
    }
}
//# sourceMappingURL=aptos-provider-wrapper.js.map